
import moment from 'moment-timezone';

const stateTimeZones = {
  1: 'America/Chicago',       // Alabama
  2: 'America/Anchorage',     // Alaska
  3: 'America/Phoenix',       // Arizona
  4: 'America/Chicago',       // Arkansas
  5: 'America/Los_Angeles',   // California
  6: 'America/Denver',        // Colorado
  7: 'America/New_York',      // Connecticut
  8: 'America/New_York',      // Delaware
  9: 'America/New_York',      // Florida
  10: 'America/New_York',     // Georgia
  11: 'Pacific/Honolulu',     // Hawaii
  12: 'America/Boise',        // Idaho
  13: 'America/Chicago',      // Illinois
  14: 'America/Indiana/Indianapolis', // Indiana
  15: 'America/Chicago',      // Iowa
  16: 'America/Chicago',      // Kansas
  17: 'America/New_York',     // Kentucky
  18: 'America/Chicago',      // Louisiana
  19: 'America/New_York',     // Maine
  20: 'America/New_York',     // Maryland
  21: 'America/New_York',     // Massachusetts
  22: 'America/Detroit',      // Michigan
  23: 'America/Chicago',      // Minnesota
  24: 'America/Chicago',      // Mississippi
  25: 'America/Chicago',      // Missouri
  26: 'America/Denver',       // Montana
  27: 'America/Chicago',      // Nebraska
  28: 'America/Los_Angeles',  // Nevada
  29: 'America/New_York',     // New Hampshire
  30: 'America/New_York',     // New Jersey
  31: 'America/Denver',       // New Mexico
  32: 'America/New_York',     // New York
  33: 'America/New_York',     // North Carolina
  34: 'America/Chicago',      // North Dakota
  35: 'America/New_York',     // Ohio
  36: 'America/Chicago',      // Oklahoma
  37: 'America/Los_Angeles',  // Oregon
  38: 'America/New_York',     // Pennsylvania
  39: 'America/New_York',     // Rhode Island
  40: 'America/New_York',     // South Carolina
  41: 'America/Chicago',      // South Dakota
  42: 'America/Chicago',      // Tennessee
  43: 'America/Chicago',      // Texas
  44: 'America/Denver',       // Utah
  45: 'America/New_York',     // Vermont
  46: 'America/New_York',     // Virginia
  47: 'America/Los_Angeles',  // Washington
  48: 'America/New_York',     // West Virginia
  49: 'America/Chicago',      // Wisconsin
  50: 'America/Denver'        // Wyoming
};

export const getStateTime = stateId => {
  const timezone = stateTimeZones[stateId];
  if (!timezone) {
      // console.log('Error: No time zone for this stateId', stateId)
  }
  const time = timezone ? moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss') : '';
  return time;
}

  export const getColorClass = status => {
    if (status === 1) {
      return 'efs-status-color__requested';
    }
    if (status === 2) {
      return 'efs-status-color__issued';
    }
    if (status === 3) {
      return 'efs-status-color__rejected';
    }
    if (status === 4) {
      return 'efs-status-color__sent';
    }
    if (status === 5) {
        return 'efs-status-color__void';
    } else {
      return 'efs-status-color__rejected';
    }
  };
